import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import ModalContainer from '@modals/ModalContainer';
import { useFlow } from '@router/stackflow';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import useLogout from './hooks/useLogout';

const LogoutModal: ActivityComponentType = () => {
  const { pop } = useFlow();
  const logout = useLogout();
  return (
        <Modal>
            <ModalContainer>
                <Column fullWidth align='center' spacing={28}>
                    <Column spacing={8} align='center'>
                        <Text size='2xl' fontWeight='bold'>
                            로그아웃
                        </Text>
                        <Text size='lg'>로그아웃 하시겠습니까?</Text>
                    </Column>
                    <Column fullWidth spacing={10}>
                        <Button onClick={pop}
                                fullWidth
                                variant='secondary'
                                size='sm'>
                            취소
                        </Button>
                        <Button size='sm' onClick={logout} fullWidth>
                            로그아웃
                        </Button>
                    </Column>
                </Column>
            </ModalContainer>
        </Modal>
  );
};

export default LogoutModal;
